import React from 'react';
import { connect } from 'react-redux';

import BuilderAx          from 'app/actions/company-admin/builder-dashboard';
import Checkbox           from 'app/components/common/checkbox';
import CurrencyInput      from 'app/components/common/currency-input';
import Icon               from 'app/components/common/icon';
import NonprofitInput     from 'app/components/common/nonprofit-input';
import RteEditor          from 'app/components/common/rich-text/editor';
import StandardInput      from 'app/components/common/standard-input';
import StandardSelect     from 'app/components/common/standard-select';
import UploadedImageInput from 'app/components/common/uploaded-image-input';
import EntityInput        from 'app/components/company-admin/common/entity-input';
import Builder            from 'app/components/company-admin/layout/builder';
import BuilderFooter      from 'app/components/company-admin/layout/builder-footer';
import BuilderIterable    from 'app/components/company-admin/layout/builder-iterable';
import BuilderSection     from 'app/components/company-admin/layout/builder-section';
import helpers            from 'app/helpers/company-dashboards';
import Ps                 from 'app/helpers/publish-statuses';
import CadminSlx          from 'app/selectors/company-admin/';
import BuilderSlx         from 'app/selectors/company-admin/builder-dashboard';

const defaultRangeOpts = [
  {label: 'All time', value: true},
  {label: 'Current year', value: false},
];

const hideMatchOpts = [
  {label: 'Combine as "donations"', value: true},
  {label: 'Show both separately', value: false},
];

class DashboardBuilder extends React.PureComponent {

  constructor(props) {
    super(props);

    this.state = {
      showAllYears: false,
    };

    this.onClickSave = this.onClickSave.bind(this);
    this.onChangeLogo = this.onChangeLogo.bind(this);
    this.onChangeEmployeesCanView = this.onChangeEmployeesCanView.bind(this);
    this.onChangeLinkCanView = this.onChangeLinkCanView.bind(this);
    this.onChangeShowSectionMatch = this.onChangeShowSectionMatch.bind(this);
    this.onClickToggleAllYears = this.onClickToggleAllYears.bind(this);
    this.onChangeShowSectionVolunteer = this.onChangeShowSectionVolunteer.bind(this);
    this.onChangeShowSectionGrant = this.onChangeShowSectionGrant.bind(this);
    this.onChangeShowSectionGift = this.onChangeShowSectionGift.bind(this);
    this.onChangeShowCustomerGifts = this.onChangeShowCustomerGifts.bind(this);
    this.onChangeShowEmployeeGifts = this.onChangeShowEmployeeGifts.bind(this);
    this.onChangeShowTotalMatch = this.onChangeShowTotalMatch.bind(this);
    this.onChangeShowTotalVolunteer = this.onChangeShowTotalVolunteer.bind(this);
    this.onChangeShowTotalGrant = this.onChangeShowTotalGrant.bind(this);
    this.onChangeShowTotalGift = this.onChangeShowTotalGift.bind(this);
    this.onChangeShowTotalCombined = this.onChangeShowTotalCombined.bind(this);
    this.onChangeMissionText = this.onChangeMissionText.bind(this);
    this.onChangeProgramDetailsText = this.onChangeProgramDetailsText.bind(this);
    this.onClickAddLovedNonprofit = this.onClickAddLovedNonprofit.bind(this);
    this.onRemoveLovedNonprofit = this.onRemoveLovedNonprofit.bind(this);
    this.onClickAddEvent = this.onClickAddEvent.bind(this);
    this.onRemoveEvent = this.onRemoveEvent.bind(this);
    this.onClickAddCampaign = this.onClickAddCampaign.bind(this);
    this.onRemoveCampaign = this.onRemoveCampaign.bind(this);
    this.onChangeHasSocialFeed = this.onChangeHasSocialFeed.bind(this);
    this.onSelectDefaultRange = this.onSelectDefaultRange.bind(this);
    this.onSelectHideMatch = this.onSelectHideMatch.bind(this);
  }

  get hasIntl() {
    return !!this.props.company?.features?.international;
  }

  /*
   *  UI Events
   */

  onClickSave() {
    this.props.save();
  }

  onClickAddLovedNonprofit() {
    const index = this.props.lovedNonprofits.length;
    this.props.setLovedNonprofit(null, index);
  }
  onChangeLovedNonprofit(index, nonprofit) {
    this.props.setLovedNonprofit(nonprofit, index);
  }
  onRemoveLovedNonprofit(index) {
    this.props.removeLovedNonprofit(index);
  }

  onClickAddEvent() {
    const index = this.props.volEvents.length;
    this.props.setVolEvent(null, index);
  }
  onChangeEvent(index, volEvent) {
    this.props.setVolEvent(volEvent, index);
  }
  onRemoveEvent(index) {
    this.props.removeVolEvent(index);
  }

  onClickAddCampaign() {
    const index = this.props.campaigns.length;
    this.props.setCampaign(null, index);
  }
  onChangeCampaign(index, campaign) {
    this.props.setCampaign(campaign, index);
  }
  onRemoveCampaign(index) {
    this.props.removeCampaign(index);
  }

  onChangeHasSocialFeed(event) {
    const hasSocialFeed = event.target.checked;
    this.props.setKeyVal('hasSocialFeed', hasSocialFeed);
  }

  onSelectDefaultRange(defaultRangeAll) {
    this.props.setKeyVal('defaultRangeAll', defaultRangeAll);
  }
  onSelectHideMatch(hideMatchLanguage) {
    this.props.setKeyVal('hideMatchLanguage', hideMatchLanguage);
  }

  onChangeEmployeesCanView(event) {
    const employeesCanView = event.target.checked;
    this.props.setKeyVal('employeesCanView', employeesCanView);
  }

  onChangeLinkCanView(event) {
    const linkCanView = event.target.checked;
    this.props.setKeyVal('linkCanView', linkCanView);
  }

  onChangeShowSectionMatch(event) {
    const showSectionMatch = event.target.checked;
    this.props.setKeyVal('showSectionMatch', showSectionMatch);
  }

  onClickToggleAllYears() {
    this.setState((prevState) => {
      return {showAllYears: !prevState.showAllYears};
    });
  }

  onChangeGivingGoal(year, {amount}) {
    const givingYearGoalMap = {
      ...this.props.givingYearGoalMap,
      [year]: amount,
    };
    this.props.setKeyVal('givingYearGoalMap', givingYearGoalMap);
  }

  onChangeShowSectionVolunteer(event) {
    const showSectionVolunteer = event.target.checked;
    this.props.setKeyVal('showSectionVolunteer', showSectionVolunteer);
  }

  onChangeShowSectionGrant(event) {
    const showSectionGrant = event.target.checked;
    this.props.setKeyVal('showSectionGrant', showSectionGrant);
  }

  onChangeShowSectionGift(event) {
    const showSectionGift = event.target.checked;
    this.props.setKeyVal('showSectionGift', showSectionGift);
  }

  onChangeShowCustomerGifts(event) {
    const showCustomerGifts = event.target.checked;
    this.props.setKeyVal('showCustomerGifts', showCustomerGifts);
  }
  onChangeShowEmployeeGifts(event) {
    const showEmployeeGifts = event.target.checked;
    this.props.setKeyVal('showEmployeeGifts', showEmployeeGifts);
  }

  onChangeShowTotalMatch(event) {
    const showTotalMatch = event.target.checked;
    this.props.setKeyVal('showTotalMatch', showTotalMatch);
  }
  onChangeShowTotalVolunteer(event) {
    const showTotalVolunteer = event.target.checked;
    this.props.setKeyVal('showTotalVolunteer', showTotalVolunteer);
  }
  onChangeShowTotalGrant(event) {
    const showTotalGrant = event.target.checked;
    this.props.setKeyVal('showTotalGrant', showTotalGrant);
  }
  onChangeShowTotalGift(event) {
    const showTotalGift = event.target.checked;
    this.props.setKeyVal('showTotalGift', showTotalGift);
  }
  onChangeShowTotalCombined(event) {
    const showTotalCombined = event.target.checked;
    this.props.setKeyVal('showTotalCombined', showTotalCombined);
  }

  onChangeMissionText(md) {
    this.props.setKeyVal('missionText', md);
  }

  onChangeProgramDetailsText(md) {
    this.props.setKeyVal('programDetailsText', md);
  }

  onChangeLogo(logoPath) {
    this.props.setKeyVal('logoPath', logoPath);
  }

  /*
   *  Render Sections
   */

  renderSectionLogo() {
    const { logoPath } = this.props;
    return (
      <BuilderSection title="Logo">
        <UploadedImageInput
          name="logo"
          label="Logo Image"
          onChange={this.onChangeLogo}
          s3PathParts={['company-dashboards']}
          maxImageWidth={512}
          pathValue={logoPath}
        />
      </BuilderSection>
    );
  }

  renderSectionMission() {
    const {hasLoaded, missionText} = this.props;
    return (
      <BuilderSection title="Mission / Intro">
        {hasLoaded && (
          <RteEditor initialMd={missionText || ''} onChange={this.onChangeMissionText} name="missionText" placeholder="Mission" />
        )}
      </BuilderSection>
    );
  }

  renderSectionTotals() {
    const {hasLoaded, showTotalMatch, showTotalVolunteer, showTotalGrant, showTotalGift, showTotalCombined} = this.props;

    return (
      <BuilderSection title="Totals">
        <div className="cadmin-builder-checkbox">
          <Checkbox id="checkbox-show-total-match" onChange={this.onChangeShowTotalMatch} checked={showTotalMatch} />
          <label htmlFor="checkbox-show-total-match">Donations & Matches</label>
        </div>
        <div className="cadmin-builder-checkbox">
          <Checkbox id="checkbox-show-total-vol" onChange={this.onChangeShowTotalVolunteer} checked={showTotalVolunteer} />
          <label htmlFor="checkbox-show-total-vol">Hours Volunteered</label>
        </div>
        <div className="cadmin-builder-checkbox">
          <Checkbox id="checkbox-show-total-grant" onChange={this.onChangeShowTotalGrant} checked={showTotalGrant} />
          <label htmlFor="checkbox-show-total-grant">Granted</label>
        </div>
        <div className="cadmin-builder-checkbox">
          <Checkbox id="checkbox-show-total-gift" onChange={this.onChangeShowTotalGift} checked={showTotalGift} />
          <label htmlFor="checkbox-show-total-gift">Gifted</label>
        </div>
        <div className="cadmin-builder-checkbox">
          <Checkbox id="checkbox-show-total-comb" onChange={this.onChangeShowTotalCombined} checked={showTotalCombined} />
          <label htmlFor="checkbox-show-total-comb">Total Donated</label>
        </div>
      </BuilderSection>
    );
  }

  renderSectionCampaigns() {
    const { campaigns, company } = this.props;
    return (
      <BuilderSection title="Campaigns">
        <div className="cadmin-dbb-camps-camps">
          {campaigns.map((campaign, index) => {
            return (
              <BuilderIterable index={index} key={index} onDelete={this.onRemoveCampaign}>
                <EntityInput.Campaign publishStatuses={Ps.nonDeleted} onChange={this.onChangeCampaign.bind(this, index)} campaignId={campaign?.id} />
              </BuilderIterable>
            );
          })}
          <button className="btn blue small cadmin-builder-iterable-add" onClick={this.onClickAddCampaign}>+ Add Campaign</button>
        </div>
      </BuilderSection>
    );
  }

  renderSectionSocial() {
    const {hasSocialFeed} = this.props;

    const topRight = (
      <Checkbox isToggle checked={hasSocialFeed} onChange={this.onChangeHasSocialFeed} />
    );
    return (
      <BuilderSection title="Activity Feed" topRight={topRight}>
        <div className="italic">Only All-Access Admins can post here.</div>
      </BuilderSection>
    );
  }

  renderSectionMatch() {
    const {company, showSectionMatch, givingYearGoalMap} = this.props;
    const {showAllYears} = this.state;
    const {currentYear, manageableYears} = company;
    const allYears = manageableYears.map(my => my.year).reverse();

    const topRight = <Checkbox isToggle checked={showSectionMatch} onChange={this.onChangeShowSectionMatch} />;
    return (
      <BuilderSection title="Giving Program" topRight={topRight}>
        {allYears.map((year, i) => {
          const isCurrent = year === currentYear;
          const shouldShow = !!(showAllYears || isCurrent);
          if (!shouldShow) return null;
          const isFirst = (i === 0) || !showAllYears;
          const goal = helpers.goalForYear(givingYearGoalMap, year);

          return (
            <div key={year} className="cadmin-dbb-year-goal">
              {isFirst ? (<>
                <div className="_flex _align-center _justify-between">
                  <label>{`${year} Goal`}</label>
                  <button className="link-btn" onClick={this.onClickToggleAllYears}>{showAllYears ? 'Just show current' : 'Show all years'}</button>
                </div>
              </>) : (<>
                <label>{`${year} Goal`}</label>
              </>)}
              <CurrencyInput amount={goal} onChange={this.onChangeGivingGoal.bind(this, year)} allowNull />
            </div>
          );
        })}
      </BuilderSection>
    );
  }

  renderSectionVolunteer() {
    const { showSectionVolunteer, volEvents, company } = this.props;
    const topRight = (
      <Checkbox isToggle checked={showSectionVolunteer} onChange={this.onChangeShowSectionVolunteer} />
    );
    return (
      <BuilderSection title="Volunteer Program" topRight={topRight}>
        <div className="cadmin-dbb-vol-events">
          {volEvents.map((volEvent, index) => {
            return (
              <BuilderIterable index={index} key={index} onDelete={this.onRemoveEvent}>
                <EntityInput.VolEvent publishStatuses={Ps.nonDeleted} volEventId={volEvent?.id} onChange={this.onChangeEvent.bind(this, index)} />
              </BuilderIterable>
            );
          })}
          <button className="btn blue small cadmin-builder-iterable-add" onClick={this.onClickAddEvent}>+ Add Opportunity</button>
        </div>
      </BuilderSection>
    );
  }

  renderSectionGrant() {
    const { showSectionGrant } = this.props;
    const topRight = (
      <Checkbox isToggle checked={showSectionGrant} onChange={this.onChangeShowSectionGrant} />
    );
    return (
      <BuilderSection title="Grant Program" topRight={topRight} />
    );
  }

  renderSectionGift() {
    const { showSectionGift, showCustomerGifts, showEmployeeGifts, company } = this.props;
    const topRight = (
      <Checkbox isToggle checked={showSectionGift} onChange={this.onChangeShowSectionGift} />
    );
    return (
      <BuilderSection title="Gift Program" className="cadmin-dbb-gift" topRight={topRight}>
        <div className="cadmin-builder-checkbox">
          <Checkbox id="checkbox-show-customer-gifts" onChange={this.onChangeShowCustomerGifts} checked={showCustomerGifts} />
          <label htmlFor="checkbox-show-customer-gifts">Customer Impact</label>
        </div>
        <div className="cadmin-builder-checkbox">
          <Checkbox id="checkbox-show-employee-gifts" onChange={this.onChangeShowEmployeeGifts} checked={showEmployeeGifts} />
          <label htmlFor="checkbox-show-employee-gifts">Employee Gifts</label>
        </div>
      </BuilderSection>
    );
  }

  renderSectionCommunity() {
    const { hasLoaded, lovedNonprofits, programDetailsText } = this.props;
    return (
      <BuilderSection title="Our Community" className="cadmin-dbb-comm">
        <label>Nonprofits We Love</label>
        <div className="cadmin-dbb-comm-loved-nps">
          {lovedNonprofits.map((nonprofit, index) => {
            return (
              <BuilderIterable index={index} key={index} onDelete={this.onRemoveLovedNonprofit}>
                <NonprofitInput onChange={this.onChangeLovedNonprofit.bind(this, index)} selectedNonprofit={nonprofit} intl={this.hasIntl} />
              </BuilderIterable>
            );
          })}
          <button className="btn blue small cadmin-builder-iterable-add" onClick={this.onClickAddLovedNonprofit}>+ Add Nonprofit</button>
        </div>

        <label>Program Details</label>
        {hasLoaded && (
          <RteEditor initialMd={programDetailsText || ''} onChange={this.onChangeProgramDetailsText} name="programDetailsText" placeholder="Program Details" />
        )}
        {/* className="cadmin-dbb-comm-pd-text" */}
      </BuilderSection>
    );
  }

  renderSectionGeneral() {
    const {defaultRangeAll, hideMatchLanguage} = this.props;

    return (
      <BuilderSection title="General Settings" className="cadmin-dbb-general">
        <div className="_mb-12">
          <label>Default Date Range</label>
          <StandardSelect options={defaultRangeOpts} onSelect={this.onSelectDefaultRange} value={defaultRangeAll} />
        </div>
        <div>
          <label>Donations & Matches Display</label>
          <StandardSelect options={hideMatchOpts} onSelect={this.onSelectHideMatch} value={hideMatchLanguage} />
        </div>
      </BuilderSection>
    );
  }

  renderSectionSharing() {
    const { employeesCanView, linkCanView } = this.props;
    return (
      <BuilderSection title="Sharing Settings" className="cadmin-dbb-sharing">
        <div className="cadmin-builder-toggle">
          <span className="cadmin-builder-toggle-badge">Recommended</span>
          <label htmlFor="checkbox-emps-can-view">Employee access to dashboard</label>
          <Checkbox id="checkbox-emps-can-view" isToggle checked={employeesCanView} onChange={this.onChangeEmployeesCanView} />
        </div>
        <div className="cadmin-builder-toggle">
          <label htmlFor="checkbox-link-can-view">Anyone with the link can view</label>
          <Checkbox id="checkbox-link-can-view" isToggle checked={linkCanView} onChange={this.onChangeLinkCanView} />
        </div>
      </BuilderSection>
    );
  }

  renderFooter() {
    const { hasTouched, savePending } = this.props;
    const disabled = !hasTouched || savePending;
    const btnText = savePending ? 'Saving...' : 'Save';
    return (
      <BuilderFooter className="cadmin-dbb-bottom">
        <div className="cadmin-builder-bottom-actions">
          <button className="btn green" disabled={disabled} onClick={this.onClickSave}>{btnText}</button>
        </div>
      </BuilderFooter>
    );
  }

  render() {
    return (
      <Builder footer={this.renderFooter()} className="cadmin-dbb">
        {this.renderSectionLogo()}
        {this.renderSectionMission()}
        {this.renderSectionTotals()}
        {this.renderSectionCampaigns()}
        {this.renderSectionSocial()}
        {this.renderSectionMatch()}
        {this.renderSectionVolunteer()}
        {this.renderSectionGrant()}
        {this.renderSectionGift()}
        {this.renderSectionCommunity()}
        {this.renderSectionGeneral()}
        {this.renderSectionSharing()}
      </Builder>
    );
  }

}

const stateToProps = (state) => ({
  company: CadminSlx.company(state),

  hasTouched: BuilderSlx.hasTouched(state),
  hasLoaded: BuilderSlx.hasLoaded(state),
  savePending: BuilderSlx.savePending(state),
  logoPath: BuilderSlx.logoPath(state),
  lovedNonprofits: BuilderSlx.lovedNonprofits(state),
  campaigns: BuilderSlx.campaigns(state),
  volEvents: BuilderSlx.volEvents(state),
  employeesCanView: BuilderSlx.employeesCanView(state),
  linkCanView: BuilderSlx.linkCanView(state),
  showSectionMatch: BuilderSlx.showSectionMatch(state),
  showSectionVolunteer: BuilderSlx.showSectionVolunteer(state),
  showSectionGrant: BuilderSlx.showSectionGrant(state),
  showSectionGift: BuilderSlx.showSectionGift(state),
  showCustomerGifts: BuilderSlx.showCustomerGifts(state),
  showEmployeeGifts: BuilderSlx.showEmployeeGifts(state),
  missionText: BuilderSlx.missionText(state),
  hasSocialFeed: BuilderSlx.hasSocialFeed(state),
  programDetailsText: BuilderSlx.programDetailsText(state),
  showTotalMatch: BuilderSlx.showTotalMatch(state),
  showTotalVolunteer: BuilderSlx.showTotalVolunteer(state),
  showTotalGrant: BuilderSlx.showTotalGrant(state),
  showTotalGift: BuilderSlx.showTotalGift(state),
  showTotalCombined: BuilderSlx.showTotalCombined(state),
  givingYearGoalMap: BuilderSlx.givingYearGoalMap(state),
  defaultRangeAll: BuilderSlx.defaultRangeAll(state),
  hideMatchLanguage: BuilderSlx.hideMatchLanguage(state),
});

const dispatchToProps = (dispatch) => ({
  setKeyVal: (key, val) => dispatch(BuilderAx.setKeyVal(key, val)),
  setLovedNonprofit: (nonprofit, index) => dispatch(BuilderAx.setLovedNonprofit(nonprofit, index)),
  removeLovedNonprofit: (index) => dispatch(BuilderAx.removeLovedNonprofit(index)),
  setVolEvent: (volEvent, index) => dispatch(BuilderAx.setVolEvent(volEvent, index)),
  removeVolEvent: (index) => dispatch(BuilderAx.removeVolEvent(index)),
  setCampaign: (campaign, index) => dispatch(BuilderAx.setCampaign(campaign, index)),
  removeCampaign: (index) => dispatch(BuilderAx.removeCampaign(index)),
  save: () => dispatch(BuilderAx.save()),
});

export default connect(stateToProps, dispatchToProps)(DashboardBuilder);
